import { updateItems } from '@/mocks/home';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
          <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
          最新动态
        </h2>
        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300 space-y-6">
            {updateItems.map((item) => (
              <div key={item.title} className="relative group">
                <span className="absolute -left-[calc(2rem+5px)] top-1 w-2.5 h-2.5 bg-primary-500 rounded-full border-2 border-background-100 transition-transform duration-200 group-hover:scale-125"></span>
                <time className="block text-xs text-secondary-500 mb-1 font-medium">{item.time}</time>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}